import { twJoin, twMerge } from '@troon/tailwind-preset/merge';
import type { ParentProps, JSX } from 'solid-js';

type Props = ParentProps<
	JSX.HTMLAttributes<HTMLDivElement> & {
		size?: 'md' | 'xl' | 'lg' | 'sm';
	}
>;

export function Container(props: Props) {
	return (
		<div
			{...props}
			class={twMerge(
				twJoin(
					'container mx-auto flex w-full flex-col gap-8 px-4 sm:px-6 md:px-12',
					props.size === 'xl' && 'max-w-screen-xl lg:px-28',
					props.size === 'lg' && 'max-w-screen-lg',
					props.size === 'md' && 'max-w-screen-md',
					props.size === 'sm' && 'max-w-screen-sm',
				),
				props.class,
			)}
		/>
	);
}
